import React, { useEffect, useRef } from "react";
import QRCode from "qrcode";

/** Renders a scannable QR for a WhatsApp short link. */
const QrImage = ({ value, size = 112, className = "" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!value || !canvasRef.current) return;
    QRCode.toCanvas(canvasRef.current, value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: "M",
      color: { dark: "#111827", light: "#ffffff" },
    }).catch(() => {});
  }, [value, size]);

  if (!value) return null;

  return (
    <canvas
      ref={canvasRef}
      width={size}
      height={size}
      className={className}
      aria-label="WhatsApp QR code"
    />
  );
};

export async function downloadQrPng(value, filename = "whatsapp-qr.png") {
  if (!value) return;
  const dataUrl = await QRCode.toDataURL(value, {
    width: 512,
    margin: 2,
    errorCorrectionLevel: "M",
  });
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  a.click();
}

export default QrImage;
